import { render, staticRenderFns } from "./subsidyApplicationDetails.vue?vue&type=template&id=32210b74&scoped=true"
import script from "./subsidyApplicationDetails.vue?vue&type=script&lang=js"
export * from "./subsidyApplicationDetails.vue?vue&type=script&lang=js"
import style0 from "./subsidyApplicationDetails.vue?vue&type=style&index=0&id=32210b74&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32210b74",
  null
  
)

export default component.exports